import { render, staticRenderFns } from "./spotLogo.vue?vue&type=template&id=5addda50&scoped=true&"
import script from "./spotLogo.vue?vue&type=script&lang=js&"
export * from "./spotLogo.vue?vue&type=script&lang=js&"
import style0 from "./spotLogo.vue?vue&type=style&index=0&id=5addda50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5addda50",
  null
  
)

export default component.exports